import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'

interface FCFNoteDialogProps {
  open: boolean
  isLoading: boolean
  onClose: () => void
  onSubmit: (note: string) => void
  initialNote?: string
}

const FCFNoteDialog = ({ open, isLoading, onClose, onSubmit, initialNote = '' }: FCFNoteDialogProps) => {
  const [noteText, setNoteText] = useState(initialNote)

  useEffect(() => {
    setNoteText(initialNote)
  }, [initialNote])

  const handleSubmit = useCallback(() => {
    if (noteText.trim()) {
      onSubmit(noteText.trim())
    }
  }, [noteText, onSubmit])

  const handleClear = useCallback(() => {
    setNoteText('')
    onSubmit('')
    onClose()
  }, [onSubmit, onClose])

  const handleClose = useCallback(() => {
    onClose()
  }, [onClose])

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Note to FCF Document</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Note"
          type="text"
          fullWidth
          variant="outlined"
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
          multiline
          rows={4}
          placeholder="Enter your note here..."
          disabled={isLoading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={handleClear} variant="outlined" color="error" disabled={isLoading}>
          Clear
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!noteText?.trim() || isLoading}>
          {isLoading ? 'Adding...' : 'Add Note'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default FCFNoteDialog
